<template>
  <div v-html="apply.result"></div>
</template>

<script>
export default {
  name: "form-pay",
  data() {
    return {
      apply: {}
    }
  },
  async mounted() {
    let info = JSON.parse(this.$route.query.obj)
    try {
      this.apply = await this.$store.dispatch('offine/payGoods', info)
      console.log('this.apply', this.apply)
      document.write(this.apply.result)
    } catch (error) {
      console.log(error);
      this.$router.back()
    }

  }
}
</script>